<!--dialog to create a new project
component used in Overview.vue
In (ui) discovery tools-> overview-> on rhs 'create new projet' button
-->
<template>
  <x-dialog
    width="70%"
    :dialogTitle="dialogTitle"
    :dialogState="dialogState"
    @toggleModal="closeDialog"
    :actions="{
      show: true,
      secondaryButtonFunction: closeDialog,
      primaryButtonFunction: saveData,
      primaryButtonShow: true,
      secondaryButtonText: 'Cancel',
      primaryButtonText: 'Create'
    }"
    :data-test-id="`${dataTestId}`"
  >
    <template slot="dialog_data">
      <loader v-if="loadingState" />
      <v-card-text class="px-8 ml-4">
        <v-row align="center" class="my-4" no-gutters>
          <v-col md="3">
            <span class="formInputLabel mt-0">Project type</span>
          </v-col>
        </v-row>
        <v-row align="center" class="my-4" no-gutters>
          <v-btn-toggle
            group
            tile
            v-model="projectType"
            mandatory
            elevation="0"
            class="groupButtons px-0 overflowAuto"
          >
            <v-btn
              v-for="item in getProjectTypeList"
              :key="item.key"
              :value="item.val"
              :ripple="false"
              class="ma-0 groupItems"
              :data-test-id="`${dataTestId}__${item.key}`"
              >{{ item.val }}</v-btn
            >
          </v-btn-toggle>
        </v-row>
        <v-row align="center" class="my-4" no-gutters>
          <v-col md="3">
            <span class="formInputLabel">
              Project name
              <sup class="red--text">*</sup>
            </span>
          </v-col>
        </v-row>
        <v-row align="center" class="my-4" no-gutters :data-test-id="`${dataTestId}__project-name-input-box-wrapper`">
          <v-text-field
            label="Project Name"
            solo
            filled
            flat
            tile
            height="52px"
            background-color="#E5E5E5"
            v-model="projectName"
            required
          ></v-text-field>
        </v-row>
        <v-row align="center" class="my-4" no-gutters>
          <v-col md="3">
            <span class="formInputLabel">External reference</span>
          </v-col>
        </v-row>
        <v-row align="center" class="my-4" no-gutters :data-test-id="`${dataTestId}__external-reference-input-box-wrapper`">
          <v-text-field
            label="External Reference"
            solo
            filled
            flat
            height="52px"
            background-color="#E5E5E5"
            v-model="extRefName"
            required
          ></v-text-field>
        </v-row>
        <v-row align="center" class="my-4" no-gutters>
          <v-col md="3">
            <span class="formInputLabel">
              Project description
              <sup class="red--text">*</sup>
            </span>
          </v-col>
        </v-row>
        <v-row align="center" class="my-4" no-gutters>
          <quill-editor
            v-model="projectDescription"
            :options="quillOptions"
            :data-test-id="`${dataTestId}__project-description-editor`"
          ></quill-editor>
        </v-row>
        <v-row
          align="center"
          class="my-4"
          no-gutters
          v-if="!(projectType === 'Discovery project')"
        >
          <v-col md="3">
            <span class="formInputLabel">Include Archives</span>
          </v-col>
        </v-row>
        <v-row
          class=" my-4 include-archieve positionRelative"
          align="center"
          no-gutters
          v-if="!(projectType === 'Discovery project')"
          :data-test-id="`${dataTestId}__include-archives-select-box-wrapper`"
        >
          <v-autocomplete
            ref="includeAutocomplete"
            name="includeData"
            label="Include Archives"
            solo
            flat
            filled
            height="52px"
            hide-selected
            type
            v-model="include"
            background-color="#E5E5E5 !important"
            attach=".include-archieve"
            :items="usersList"
            item-text="fullName"
            item-value="id"
            append-icon="keyboard_arrow_down"
            v-on:keyup.enter="
              addItems(include, includeArchiveList), getArchiveTotal()
            "
            v-on:change="
              addItems(include, includeArchiveList), getArchiveTotal()
            "
          >
            <template v-slot:item="data">
              <v-list-item-content>
                <v-list-item-title>{{ data.item.fullName }}</v-list-item-title>
                <v-list-item-subtitle>{{
                  data.item.email[0]
                }}</v-list-item-subtitle>
              </v-list-item-content>
            </template>
          </v-autocomplete>
        </v-row>
        <v-row
          align="center"
          class="my-4"
          no-gutters
          v-if="!(projectType === 'Discovery project')"
          :data-test-id="`${dataTestId}__include-archives-tag-list`"
        >
          <div class="list-container" v-if="includeArchiveList.length > 0">
            <tag
              v-for="(item,index) in includeArchiveList"
              :key="item.id"
              :text="item.name"
              data-class="dynamicTagsdark"
              :showDelete="true"
              @click="deleteItemtype(item, includeArchiveList)"
              :data-test-id="`${dataTestId}__include-archives-tag-list-item-${index+1}`"
            ></tag>
          </div>
        </v-row>
        <v-row
          align="center"
          class="my-4"
          no-gutters
          v-if="!(projectType === 'Discovery project')"
        >
          <v-col md="3">
            <span class="formInputLabel">Exclude Archives</span>
          </v-col>
        </v-row>
        <v-row
          class="my-4 exclude-archieve positionRelative"
          align="center"
          no-gutters
          v-if="!(projectType === 'Discovery project')"
          :data-test-id="`${dataTestId}__exclude-archives-select-box-wrapper`"
        >
          <v-autocomplete
            ref="excludeAutocomplete"
            name="excludeData"
            label="Exclude Archives"
            solo
            flat
            filled
            height="52px"
            hide-selected
            type
            v-model="exclude"
            background-color="#E5E5E5 !important"
            attach=".exclude-archieve"
            :items="usersList"
            item-text="fullName"
            item-value="id"
            append-icon="keyboard_arrow_down"
            v-on:keyup.enter="
              addItems(exclude, excludeArchiveList), getArchiveTotal()
            "
            v-on:change="
              addItems(exclude, excludeArchiveList), getArchiveTotal()
            "
          >
            <template v-slot:item="data">
              <v-list-item-content>
                <v-list-item-title>{{ data.item.fullName }}</v-list-item-title>
                <v-list-item-subtitle>{{
                  data.item.email[0]
                }}</v-list-item-subtitle>
              </v-list-item-content>
            </template>
          </v-autocomplete>
        </v-row>
        <v-row
          align="center"
          class="my-4"
          no-gutters
          v-if="!(projectType === 'Discovery project')"
          :data-test-id="`${dataTestId}__exclude-archives-tag-list`"
        >
          <div class="list-container" v-if="excludeArchiveList.length > 0">
            <tag
              v-for="(item, index) in excludeArchiveList"
              :key="item.id"
              :text="item.name"
              data-class="dynamicTagsdark"
              :showDelete="true"
              @click="deleteItemtype(item, excludeArchiveList)"
              :data-test-id="`${dataTestId}__exclude-archives-tag-list-item-${index+1}`"
            ></tag>
          </div>
        </v-row>
        <v-row
          align="center"
          class="my-4"
          no-gutters
          v-if="!(projectType === 'Discovery project')"
        >
          <v-col md="3">
            <span class="formInputLabel">Search terms</span>
          </v-col>
        </v-row>
        <v-row
          align="center"
          class="my-4"
          no-gutters
          v-if="!(projectType === 'Discovery project')"
          :data-test-id="`${dataTestId}__search-term-input-box-wrapper`"
        >
          <v-text-field
            label="Enter Text and Press enter to search"
            solo
            flat
            filled
            height="52px"
            background-color="#E5E5E5 !important"
            v-model="searchItem"
            v-on:keyup.enter="
              addSearchItems(searchItem, searchKeywordList), getArchiveTotal()
            "
          ></v-text-field>
        </v-row>
        <v-row
          align="center"
          class="my-4"
          no-gutters
          v-if="!(projectType === 'Discovery project')"
          :data-test-id="`${dataTestId}__search-term-tag-list`"
        >
          <div class="list-container" v-if="searchKeywordList.length > 0">
            <tag
              v-for="(item, index) in searchKeywordList"
              :key="index"
              :text="item"
              data-class="dynamicTagsdark"
              :showDelete="true"
              @click="deleteItem(item, searchKeywordList)"
          :data-test-id="`${dataTestId}__search-term-tag-list-item-${index+1}`"
            ></tag>
          </div>
        </v-row>
        <v-row
          align="center"
          class="my-4"
          no-gutters
          v-if="!(projectType === 'Discovery project')"
        >
          <v-col sm="12">
            <v-row>
              <v-col md="3">
                <span class="formInputLabel">Date Range</span>
              </v-col>
              <v-col md="9" class="pa-0">
                <v-radio-group
                  v-model="dateRangeType"
                  row
                  @change="dateRangeTypeChanged"
                >
                  <v-radio label="All Time" value="all" :data-test-id="`${dataTestId}__all-time-radio-btn`"></v-radio>
                  <v-radio label="Custom" value="custom" :data-test-id="`${dataTestId}__custom-radio-btn`"></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
            <v-row v-show="dateRangeType !== 'all'" no-gutters>
              <v-col md="3">
                <span class="formInputLabel">Select Dates:</span>
              </v-col>
              <v-col md="9" class="pa-0">
                <Datepicker
                  class="dashboardDatepicker"
                  ref="datepicker"
                  :data-test-id="`${dataTestId}`"
                ></Datepicker>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row
          align="center"
          class="my-4"
          no-gutters
          v-if="!(projectType === 'Discovery project')"
        >
          <v-col md="3">
            <span class="formInputLabel">Archive Total</span>
          </v-col>
        </v-row>
        <v-row
          align="center"
          class="my-4"
          no-gutters
          v-if="!(projectType === 'Discovery project')"
        >
          <div class="total-div">{{ count }}</div>
        </v-row>
        <v-row
          align="center"
          class="my-4"
          no-gutters
          v-if="
            !(projectType === 'Discovery project') && activeConnectors.length
          "
        >
          <v-col md="3">
            <span class="formInputLabel">Vault Total</span>
          </v-col>
        </v-row>
        <v-row
          align="center"
          class="my-4"
          no-gutters
          v-if="
            !(projectType === 'Discovery project') && activeConnectors.length
          "
        >
          <div class="total-div">{{ vaultCount }}</div>
        </v-row>
      </v-card-text>
    </template>
  </x-dialog>
</template>

<script>
import EventBus from '@/EventBus';
import Datepicker from '@/components/Common/DateRangePicker';
import { quillEditor } from 'vue-quill-editor';
import { quillConfig } from '@/config/quill';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import SearchService from '../../services/SearchService';
import UserService from '../../services/UserService';
import ProjectService from '../../services/ProjectService';
import VaultDataService from '../../services/VaultDataService';
var findIndex = require('lodash.findindex');

export default {
  data() {
    return {
      dateRangeType: 'all',
      quillOptions: quillConfig,
      dialogState: false,
      dialogTitle: 'Create a new project',
      projectOptions: [
        {
          key: 'DISCOVERY_PROJECT',
          val: 'Discovery project',
          permission: { action: 'create', entity: 'discovery_project' }
        },
        {
          key: 'LITIGATION_PROJECT',
          val: 'Litigation Project',
          permission: { action: 'create', entity: 'litigation_project' }
        },
        {
          key: 'DATA_SUBJECT_REQUEST',
          val: 'Data Subject Project',
          permission: {
            action: 'create',
            entity: 'data_subject_request_project'
          }
        }
      ],
      vaultCount: 0,
      projectModal: {
        dbVersion: 'V1'
      },
      projectType: 'Discovery project',
      projectName: '',
      extRefName: '',
      projectDescription: '',
      include: '',
      exclude: '',
      includeArchiveList: [],
      excludeArchiveList: [],
      searchItem: '',
      searchKeywordList: [],
      startDate: new Date().toISOString().substr(0, 10),
      endDate: new Date().toISOString().substr(0, 10),
      count: 0,
      projectTypeId: '',
      allUsers: [],
      usedUsers: [],
      loadingState: false,
      dataTestId:'create-new-project-dialog'
    };
  },
  components: {
    Datepicker,
    quillEditor
  },
  created: function() {
    document.addEventListener('keyup', this.escapeKeyListener);
  },
  destroyed: function() {
    document.removeEventListener('keyup', this.escapeKeyListener);
  },
  mounted() {
    this.openDialog();
    EventBus.$on('GET_STARTRANGE_DATE', value => {
      if (value !== false) {
        this.startDate = value;
        this.getArchiveTotal();
      } else {
        return false;
      }
    });
    EventBus.$on('GET_ENDRANGE_DATE', value => {
      this.endDate = value;
      if (this.endDate < this.startDate) {
        this.count = 0;
        this.snackbar('error', this.$message.DATE_RANGE_END);
      } else if (value !== false) {
        this.endDate = value;
        this.getArchiveTotal();
      } else {
        return false;
      }
    });
    if (
      this.$can('create', 'litigation_project') ||
      this.$can('create', 'data_subject_request_project')
    ) {
      this.getUsers();
    }
  },
  methods: {
    openDialog() {
      this.dialogState = true;
    },
    // set date according to dateRangeType
    dateRangeTypeChanged() {
      if (this.dateRangeType === 'all') {
        this.startDate = new Date(this.defaultProjectStartDate)
          .toISOString()
          .substr(0, 10);
      } else {
        this.startDate = new Date(this.$refs.datepicker.dateStart)
          .toISOString()
          .substr(0, 10);
      }
      this.getArchiveTotal();
    },
    // escape key listener to close dialog when open
    escapeKeyListener: function(evt) {
      if (evt.keyCode === this.escapeKeyCode && this.dialogState) {
        this.closeDialog();
      }
    },
    // to close dialog
    closeDialog() {
      this.$emit('closeCreateProjectDialog');
    },
    /**
     * to add include and exclude archive tags
     * @param {String} item
     * @param {Array<Object>} arr
     */
    addItems(item, arr) {
      let temp = '';
      let index = findIndex(arr, el => {
        return el.id === item;
      });
      if (index < 0) {
        let itemIndex = findIndex(this.allUsers, function(o) {
          return o.id === item;
        });
        temp = {
          id: item,
          name: this.formatFullName(this.allUsers[itemIndex])
        };
        arr.push(temp);
        this.usedUsers.push(temp);
      }
    },
    /**
     * deletes include and exclude archive tags
     * @param {String} item
     * @param {Array} arr
     */
    deleteItemtype(item, arr) {
      let index = findIndex(arr, el => {
        return el === item;
      });
      let usedArrIndex = findIndex(this.usedUsers, el => {
        return el === item;
      });

      if (index >= 0) {
        arr.splice(index, 1);
        this.usedUsers.splice(usedArrIndex, 1);
        this.exclude = '';
        this.include = '';
        this.getArchiveTotal();
      }
    },
    /**
     * to add search items tags
     * @param {String} item
     * @param {Array} arr
     */
     addSearchItems(item, arr) {
      let index = findIndex(arr, el => {
        return el === item;
      });
      if (index < 0) {
        arr.push(item);
      }
      this.searchItem = '';
    },
    /**
     * to delete search items tags
     * @param {String} item
     * @param {Array} arr
     */
    deleteItem(item, arr) {
      let index = findIndex(arr, el => {
        return el === item;
      });
      if (index >= 0) {
        arr.splice(index, 1);
        this.getArchiveTotal();
      }
    },
    // return project's id
    getProjectId() {
      this.projectOptions.forEach(ele => {
        if (ele.val === this.projectType) {
          this.projectTypeId = ele.key;
        }
      });
    },
    // get exclude users id
    excludeUsersId() {
      let tempExclude = [];
      this.excludeArchiveList.forEach(val => {
        tempExclude.push(val.id);
      });
      this.excludeListId = tempExclude;
    },
    // get include users id
    includeUsersId() {
      let tempIdlist = [];
      this.includeArchiveList.forEach(val => {
        tempIdlist.push(val.id);
      });
      this.includeListId = tempIdlist;
    },
    // to save project
    async saveProjectCall() {
      try {
        this.getProjectId();
        if (this.projectType === 'Discovery project') {
          this.projectModal['externalReference'] = this.extRefName;
          this.projectModal['projectType'] = this.projectTypeId;
          this.projectModal['projectDescription'] = this.projectDescription;
          this.projectModal['projectName'] = this.projectName;
        } else {
          this.includeUsersId();
          this.excludeUsersId();
          this.projectModal['externalReference'] = this.extRefName;
          this.projectModal['projectType'] = this.projectTypeId;
          this.projectModal['projectDescription'] = this.projectDescription;
          this.projectModal['projectName'] = this.projectName;
          if (this.excludeArchiveList && this.excludeArchiveList.length > 0) {
            this.projectModal['excludedUsers'] = this.excludeListId;
          }
          if (this.includeArchiveList && this.includeArchiveList.length > 0) {
            this.projectModal['includedUsers'] = this.includeListId;
          }
          this.projectModal['startDate'] = this.computeUTCTimestamp(
            this.startDate
          );
          this.projectModal['endDate'] = this.computeUTCTimestamp(this.endDate);
          if (this.searchKeywordList && this.searchKeywordList.length > 0) {
            this.projectModal['searchTerms'] = this.searchKeywordList;
          }
        }
        await ProjectService.createProject(this.projectModal);
        EventBus.$emit('Project_Created', true);
        this.snackbar('success', this.$message.PROJECT_CREATED);
        this.closeDialog();
      } catch (err) {
        this.snackbar('error', err);
      }
    },
    // checks the fields and call function to save project
    async saveData() {
      this.loadingState = true;
      try {
        if (this.projectType === 'Discovery project') {
          if (this.projectDescription === '' || this.projectName === '') {
            this.snackbar('error', `Fields ${this.$message.CANNOT_BE_EMPTY}`);
          } else if (this.endDate < this.startDate) {
            this.count = 0;
            this.snackbar('error', this.$message.DATE_RANGE_END);
          } else {
            await this.saveProjectCall();
          }
        } else if (
          this.projectType === 'Litigation Project' ||
          this.projectType === 'Data Subject Project'
        ) {
          if (this.projectDescription !== '' && this.projectName !== '') {
            if (this.count === 0) {
              this.snackbar('error', this.$message.NO_PROJECT_ARCHIVE);
            } else if (this.endDate < this.startDate) {
              this.count = 0;
              this.snackbar('error', this.$message.DATE_RANGE_END);
            } else {
              await this.saveProjectCall();
            }
          } else {
            this.snackbar('error', `Fields ${this.$message.CANNOT_BE_EMPTY}`);
          }
        }
      } catch (err) {
        this.snackbar('error', err);
      }
      this.loadingState = false;
    },
    // load users
    async getUsers() {
      try {
        let res = await UserService.loadUsersAll(false, true);

        let listData = res.data.body[0].results;
        listData.forEach(item => {
          this.allUsers.push(item);
        });
      } catch (err) {
        this.snackbar('error', err);
      }
    },
    // get the count of total archives
    getCountParams() {
      let archiveTotal = {};
      let temp = [];
      archiveTotal['startDate'] = this.setTimeForDate(this.startDate, 0, 0, 0);
      // eslint-disable-next-line
      archiveTotal['endDate'] = this.setTimeForDate(this.endDate, 23, 59, 59);
      if (this.includeArchiveList && this.includeArchiveList.length > 0) {
        this.includeArchiveList.forEach(value => {
          temp.push(value.id);
        });
        archiveTotal['includedArchives'] = temp;
        temp = [];
      } else {
        archiveTotal['includedArchives'] = [];
      }
      if (this.excludeArchiveList && this.excludeArchiveList.length > 0) {
        this.excludeArchiveList.forEach(value => {
          temp.push(value.id);
        });
        archiveTotal['excludedArchives'] = temp;
      } else {
        archiveTotal['excludedArchives'] = [];
      }
      if (this.searchKeywordList && this.searchKeywordList.length > 0) {
        archiveTotal['searchTerms'] = this.searchKeywordList;
      } else {
        archiveTotal['searchTerms'] = [];
      }
      return JSON.stringify(archiveTotal);
    },
    // get email archive total
    async getArchiveTotal() {
      try {
        const orgId = this.orgId;
        let jsonData = this.getCountParams();
        let results = await SearchService.getArchiveCount({
          params: jsonData,
          orgId
        });
        this.count = results.data.body[0].count;
        await this.getVaultTotal();
      } catch (err) {
        this.snackbar('error', err);
      }
    },
    // get vault archive total
    async getVaultTotal() {
      if (!this.activeConnectors.length) {
        return;
      }

      try {
        const orgId = this.orgId;
        let jsonData = this.getCountParams();
        let results = await VaultDataService.getConnectorArchiveCount({
          orgId,
          bodyData: jsonData
        });

        this.vaultCount = results.data.body[0].count;
      } catch (err) {
        this.snackbar('error', err);
      }
    }
  },
  computed: {
    getProjectTypeList() {
      return this.projectOptions.filter(projectType => {
        return this.$can(
          projectType.permission.action,
          projectType.permission.entity
        );
      });
    },
    activeConnectors() {
      return this.connectorArchiveNameMap(
        null,
        'menu',
        'currentOrgActiveConnectors'
      );
    },
    // display list of unselected users
    usersList() {
      let list = this.allUsers;
      this.usedUsers.forEach(item => {
        list = list.filter(vl => {
          return vl.id !== item.id;
        });
      });
      return this.formatuserListForFullName(list);
    },
    isDiscoveryProject() {
      return this.projectType.toLowerCase() === 'discovery project';
    }
  },
  beforeDestroy() {
    EventBus.$off('CREATE_PROJECT_DIALOGUE_ISOPEN');
    EventBus.$off('GET_STARTRANGE_DATE');
    EventBus.$off('GET_ENDRANGE_DATE');
  },
  watch: {
    projectType: {
      handler: function() {
        this.rules = [];
        if (!this.isDiscoveryProject) {
          this.dateRangeTypeChanged();
        }
      },
      immediate: true
    }
  }
};
</script>

<style scoped>
.v-input__slot {
  padding: 0 !important;
  border: none !important;
  box-shadow: none !important;
  height: 52px !important;
  border-radius: none !important;
}

.v-text-field__slot {
  max-width: 100%;
}

.v-text-field__slot label {
  margin: 0px 26px !important;
}

.v-text-field__slot textarea {
  margin-top: 0px !important;
  padding: 15px 26px !important;
}

.paddingCard {
  padding: 30px 50px !important;
}

.total-div {
  background-color: #1b2342;
  width: 206px;
  height: 52px;
  color: #ffffff;

  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  text-align: left;
  padding: 14px;
}
.lower-button {
  width: 165px !important;
  margin-left: 10px;
}
.md6 {
  max-width: 46% !important;
}
.archive-list {
  list-style: none;
  padding: 0px;
}

.archive-list li {
  width: 100%;
  color: white;
  padding: 5px;
  margin-top: 10px;
}

.archive-list li.include {
  background: #1b2342;
}
.archive-list li.exclude {
  background: #1b2342;
}
.archive-list li .v-icon.material-icons.theme--light {
  color: white;
  font-size: 18px;
  float: right;
  margin-right: 10px;
}
</style>
